import { ConfirmPopup } from "primereact/confirmpopup";

import REIToggablePanel from "../components/ui/toggablePanel";

import MySavedSearch from "./SavedSearch";
import MyWatchList from "./WatchList";
import InvestarSearchHome from "./Search";
import { ReactElement, useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { REIButton, REIDialoge } from "../components/ui";
import MyDefaultProfile from "./Search/Child/defaultProfile";
import SaveThisSearch from "./Search/Child/saveThisSearch";
import { RootState } from "../store";

const InvestarSearch: React.FC = () => {
  const [showDefaultProfile, setShowDefaultProfile] = useState<boolean>(false);
  const [showSaveThisSearch, setShowSaveThisSearch] = useState<boolean>(false);
  const [searchOnlyScreen, setSearchOnlyScreen] = useState<boolean>(true);
  const filterValue = useSelector((state: RootState) => state.investar.filterValue) || null;
  const liveSearchObject = useSelector((state: RootState) => state.searchState.liveSearchObject) || null;

  const hideDefaultProfile = useCallback(() => {
    setShowDefaultProfile(false);
  }, []);

  const hideSaveThisSearch = useCallback(() => {
    setShowSaveThisSearch(false);
  }, []);

  const headerTemplate = (options: any): ReactElement<any, any> => {
    const className = `${options.className} flex w-full items-center justify-between gap-3`;

    return (
      <div className={className}>
        <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
          <span className="font-bold">Investar search</span>
        </div>

        {!searchOnlyScreen && (
          <div className="flex flex-1 justify-center">
            <REIButton
              id="invst-btn-savesearch"
              label="Save search"
              disabled={false}
              loading={false}
              icon="pi pi-save"
              classNames="max-sm:w-full"
              onClick={() => setShowSaveThisSearch(true)}
            />
          </div>
        )}

        <div className="flex flex-1 items-center justify-end gap-2">
          <REIButton
            id="invst-btn-defaultprofile"
            icon="pi pi-user-edit"
            label="My default profile"
            classNames="p-button-link"
            onClick={() => setShowDefaultProfile(true)}
          />
          {options.togglerElement}
        </div>
      </div>
    );
  };

  return (
    <>
      <ConfirmPopup />
      <REIDialoge
        showHeader={true}
        header={`Edit Default Profile`}
        visible={showDefaultProfile}
        handleEditClick={hideDefaultProfile}
        position="top"
        style={{ width: "60vw" }}
        customClass="edit-default-profile"
        contentComponent={<MyDefaultProfile closeDialog={hideDefaultProfile} />}
      ></REIDialoge>
      <REIDialoge
        showHeader={true}
        header={`Save this search`}
        visible={showSaveThisSearch}
        handleEditClick={hideSaveThisSearch}
        position="top"
        style={{ width: "60vw" }}
        customClass="save-this-search"
        contentComponent={
          <SaveThisSearch closeDialog={hideSaveThisSearch} savesearch={liveSearchObject ?? filterValue} />
        }
      ></REIDialoge>
      <div className="flex flex-col lg:flex-row flex-wrap gap-2">
        <div className="flex flex-col lg:flex-row lg:w-full gap-2">
          <div className="flex-1 lg:w-1/2 w-full">
            <REIToggablePanel
              id="invst-pnl-watchlist"
              header="My watchlist"
              istoggleable={true}
              defaultCollapse={true}
              contentComponent={<MyWatchList />}
            />
          </div>
          <div className="flex-1 lg:w-1/2 w-full">
            <REIToggablePanel
              id="invst-pnl-savedsearch"
              header="My saved search"
              istoggleable={true}
              defaultCollapse={true}
              contentComponent={<MySavedSearch />}
            />
          </div>
        </div>
        <div className="w-full">
          <REIToggablePanel
            header="Investar Search"
            istoggleable={false}
            defaultCollapse={false}
            customHeader={headerTemplate}
            contentComponent={
              <InvestarSearchHome searchOnlyScreen={searchOnlyScreen} onSearchStateChange={setSearchOnlyScreen} />
            }
          />
        </div>
      </div>
      <div className="content-center justify-center flex m-2 align-middle gap-2">
        <span className="text-center content-center italic">What do you think of Investar Search? </span>
        <REIButton
          id="invst-btn-leavefeedback"
          text
          label="Leave Feedback"
          onClick={() => {
            window.open("https://info.realestateinvestar.com.au/satisfaction-survey", "_blank");
          }}
          classNames="border-1 border-blue-200"
        ></REIButton>
      </div>
    </>
  );
};

export default InvestarSearch;
